<template>
  <nav class="navbar nav-header py-0">
    <div
      class="w-100 d-flex align-items-center justify-content-between position-relative"
    >
      <!-- Mobile -->
      <div class="d-flex align-items-center d-lg-none">
        <img src="@/core/assets/images/layout/logo-admin-transparent.png" alt="Travelcab" class="mr-2 header-logo">
        <span class="sidebar-title text-white w-50">TRAVELCAB</span>
      </div>

      <div class="d-lg-none">
        <button type="button" class="bg-transparent text-white px-0 border-0" @click="setMenu(true)">
          <i class="ri-menu-line"></i>
        </button>
      </div>

      <!-- Desktop -->
      <a
        :href="websiteUrl"
        target="_blank"
        class="d-none open-website-link text-white text-decoration-none align-items-md-center d-lg-flex justify-content-md-center"
      >
        <span class="menu-icon">
          <i class="ri-global-line"></i>
        </span>
        <span class="text-center d-none d-md-inline-block">Visitar sitio web</span>
      </a>

      <div class="d-none d-lg-flex align-items-center">
        <span v-if="user && user.affiliate_name" class="text-white mr-3" style="font-size: 13px; opacity: 0.85">
          {{ user.affiliate_name }}
        </span>
        <CitySwitcher v-if="!isAffiliate" class="mr-3" />
        <UserDropdown :user="user" @logout="logout()" />
      </div>
    </div>
  </nav>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import { UserDropdown } from "wize-admin";
import CitySwitcher from "./CitySwitcher.vue";

export default {
  name: "PageHeader",
  data() {
    return {
      showCart: false,
      categories: [],
      subcategories: [],
    };
  },
  components: {
    UserDropdown,
    CitySwitcher
  },
  computed: {
    ...mapGetters({
      user: "auth/getUser",
      isAffiliate: "auth/isAffiliate",
    }),
    websiteUrl() {
      return 'https://travelcab.net/';
    },
  },
  methods: {
    ...mapMutations({
      setMenu: "app/setMenu",
    }),
    logout() {
      this.$store.dispatch("auth/logout");
    },
  },
};
</script>

<style scoped lang="stylus">
.header-logo
  max-width: 25px
</style>
